module.exports = __webpack_public_path__ + "img/person_with_clock.98226701.svg";